import { Button } from "@material-ui/core";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";

import { ExportResult } from "../../dtos/export";
import { AjaxResult } from "../../enums/ajaxResult";
import { ApiResult } from "../../rest/baseApi";

interface Props {
    apiRequest: (() => Promise<ApiResult<ExportResult>>) | undefined;
    targetLabel: string;
    buttonLabel: string;
    disabled?: boolean;
}

export function ExportButton({
    targetLabel,
    buttonLabel,
    apiRequest,
    disabled,
}: Props) {
    const [loading, setLoading] = useState(false);
    const [exported, setExported] = useState(false);

    const handleReportResult = useCallback((reportData: ExportResult) => {
        const exportFileLink = document.createElement('a');
        const file = new Blob([reportData.csvData], { type: 'text/plain' });
        exportFileLink.href = URL.createObjectURL(file);
        exportFileLink.download = `${targetLabel} ${moment().format('YYYY-MM-DDTHH_mm_ss')}.csv`;
        exportFileLink.click();
        exportFileLink.remove();
        setExported(true);
    }, [targetLabel]);

    const exportBoxes = useCallback(() => {
        if (!apiRequest) return;
        setLoading(true);
        apiRequest().then((result) => {
            setLoading(false);
            if (result.result === AjaxResult.Success && result.data) {
                handleReportResult(result.data);
            } else {
                alert(`ERROR: failed to export ${targetLabel}`);
            }
        });
    }, [apiRequest, handleReportResult, targetLabel]);

    useEffect(() => {
        if (exported) setExported(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiRequest]);

    return (
        <Button
            variant="contained"
            color="primary"
            onClick={exportBoxes}
            disabled={disabled || loading || exported || !apiRequest}
        >
            {loading
                ? "Exporting..."
                : exported
                    ? "Exported"
                    : buttonLabel}
        </Button>
    );
}